import Link from 'gatsby-link';
import * as React from 'react';
import styled from 'styled-components';
import IImage from '../../Entities/Image';
import getSlug from '../../utils/getSlug';
import Image from '../Image/Image';

const Card = styled.div`
  margin-bottom: 2rem;
  text-align: center;
`;

const Header = styled.header`
  padding: 1rem;

  h2 {
    margin: 0;
    font-size: 1.25rem;
    text-transform: uppercase;

    + * {
      margin-top: 1rem;
    }
  }

  p {
    margin: 0;
  }
`;

const Meta = styled.small`
  color: #888;
  margin-top: 1rem;
  display: block;
  text-transform: uppercase;
`;

interface Props {
  id: string;
  image?: IImage;
  title: string;
  description?: string;
  meta?: string;
  className?: string;
}

export default (props: Props) => {
  return (
    <Card>
      <Link to={`/cases/${getSlug(props.title)}`}>
        {props.image && <Image {...props.image} />}
        <Header>
          {props.title && <h2>{props.title}</h2>}
          {props.description && <div dangerouslySetInnerHTML={{ __html: props.description }} />}
          {props.meta && <Meta>{props.meta}</Meta>}
        </Header>
      </Link>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./src/components/Card/Card.tsx